import i18n from '@/i18n/i18n.js'

const { t } = i18n.global

export const ORDER_DOCUMENT_TYPE = {
  ALL: 0,
  PROMISSORY_NOTE: 1,
  INVOICE: 2,
  XML: 3,
  PAYMENT_NOTICE: 4,
  SCANNED_PROMISSORY_NOTE: 5,
  LIEN_INQUIRY: 6,
  CKS_INQUIRY: 7,
  CATTLE_INQUIRY: 8,
  SMALL_CATTLE_INQUIRY: 9,
  DEED_INFO_INQUIRY: 10,
  PAYMENT_RECEIPT: 11,
  FIBA_ACCOUNT_CREATION_FORM: 16,
  FIBA_INDIVIDUAL_DECLARATION_FORM: 17,
  FIBA_USAGE_REMITTANCE_ORDER: 18,
  FIBA_PAYMENT_INFO: 27,
  FIBA: 19,
  APIA: 12,
  CI: 13,
  SALES_CONTRACT: 14,
  CREDIT_APPLICATION: 28,
  CREDIT_APPLICATION_SIGNED: 29,
  PRODUCER_CERTIFICATE: 30,
  REPAYMENT_SCHEDULE: 31,
  CREDIT_AGREEMENT: 32,
  AGA: 33,
  REVERSAL_INVOICE: 15,
  ORDER_RECEIPT: 20,
  LATE_FEE_INVOICE: 21,
  TRANSPORTATION_DOCUMENT: 22,
  PAID_PROMISSORY_NOTE: 23,
  FARMER_TRANSPORTATION_DOCUMENT: 24,
  GDPR: 25,
  INCOME_PROTECTED_SALE_CONTRACT: 26,
  MORTGAGE_CONTRACT: 34,
  MORTGAGE_CONTRACT_SIGNED: 35,
  SCANNED_INCOME_PROTECTED_SALE_CONTRACT: 36,
  DIGITAL_PROMISSORY_NOTE: 37,
  SUPPLEMENTARY_INVOICE: 38,
  DELIVERY_AND_CONFIRMATION_RECORD: 39,
  COMMISSION_INVOICE: 40,
  INSTALLMENT_SALES_CONTRACT: 41,
  SCANNED_INSTALLMENT_SALES_CONTRACT: 42,
  CAR_SALES_INSTALLMENT_PROMISSORY_NOTE: 43,
  CAR_SALES_CONTRACT: 44,
  SCANNED_CAR_SALES_CONTRACT: 45,
  VEHICLE_REGISTRATION: 48,
  CAR_SALES_PRE_APPLICATION_INFORMATION_FORM: 49
}

export const ORDER_DOCUMENT_TYPE_OPTIONS = [
  {
    id: ORDER_DOCUMENT_TYPE.DIGITAL_PROMISSORY_NOTE,
    text: t('constants.order_document_type.digital_promissory_note_pending_control')
  }
]

export const ORDER_DOCUMENT_TYPE_MAP = {
  [ORDER_DOCUMENT_TYPE.DIGITAL_PROMISSORY_NOTE]: t('views.admin.order_documents.promissory_note'),
  [ORDER_DOCUMENT_TYPE.VEHICLE_REGISTRATION]: t('constants.order_document_type.vehicle_registration')
}
